export default __webpack_public_path__ + "static/media/bfs.7ff5b934.PNG";